import React from 'react'

import { Navbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Layout from '@legacy/components/Website/Base/Layout'
import CenteredContainer from '@legacy/components/Website/CenteredContainer'
import FullViewportHeight from '@legacy/components/Website/FullViewportHeight'
import { H2 } from '@legacy/components/Website/Headings'
import NavBarBrand from '@legacy/components/Website/NavBarBrand'
import PaddedCenteredContainer from '@legacy/components/Website/PaddedCenteredContainer'
import Section from '@legacy/components/Website/Section'
import { useActiveProduct } from '@legacy/contexts/activeProductContext'
import { ApiError } from '@legacy/externalApi/ApiResponse'

interface LoadPartnerErrorProps {
  error: ApiError
}

const Container = styled(PaddedCenteredContainer)`
  text-align: center;
  color: ${(props) => props.theme.colors.brandA500};
`

const SpacedSection = styled.div`
  margin: 0 auto;
  width: 80%;

  @media (min-width: ${(props) => props.theme.viewport.viewport7}) {
    width: 70%;
  }

  @media (min-width: ${(props) => props.theme.viewport.viewport9}) {
    width: 50%;
  }
`

const Message = styled(SpacedSection)`
  font-size: ${(props) => props.theme.fontSizes.intro.mobile[0]};
  line-height: ${(props) => props.theme.fontSizes.intro.mobile[1]};

  @media (min-width: ${(props) => props.theme.viewport.viewport4}) {
    font-size: ${(props) => props.theme.fontSizes.intro.desktop[0]};
    line-height: ${(props) => props.theme.fontSizes.intro.desktop[1]};
  }
`

const Link = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.brandA500};

  &:visited {
    color: ${(props) => props.theme.colors.brandA500};
  }

  &:hover {
    color: ${(props) => props.theme.colors.brandB500};
  }
`

const LoadPartnerError: React.FC<React.PropsWithChildren<LoadPartnerErrorProps>> = (_props) => {
  const { t } = useTranslation()
  const {
    productUIInfo: info,
    product: { name: productName },
  } = useActiveProduct()

  return (
    <Layout>
      <FullViewportHeight>
        <CenteredContainer>
          <Navbar bg="light" expand="md">
            <NavBarBrand renderLink={false} />
          </Navbar>
        </CenteredContainer>
        <Container>
          <Section>
            <H2 brand>{t('pages.partnerLoadError.title')}</H2>
          </Section>

          <Message>{t('pages.partnerLoadError.message', { productName: productName })}</Message>

          <SpacedSection>
            <br />
            <strong>{t('models.address.labels.headOffice')}</strong>
            <br />
            Level 5, 63 York St, SYDNEY NSW 2000
            <br />
            <Link href={`tel:${info.contacts.phone.replace(/\s+/g, '')}`}>{info.contacts.phone}</Link>
            <br />
            <Link href={`mailto:${info.contacts.email}`}>{info.contacts.email}</Link>
            <br />
            <Link href="https://www.poweredbyagile.com.au/">www.poweredbyagile.com.au</Link>
          </SpacedSection>
        </Container>
      </FullViewportHeight>
    </Layout>
  )
}

export default LoadPartnerError
